module.exports = __webpack_public_path__ + "img/icon-bag.091caef4.svg";